// extracted by mini-css-extract-plugin
export var dateLabel = "_35-0";
export var dateLabelError = "_35-1";
export var fullWidth = "_35-2";
export var smaller = "_35-3";